import React from 'react';
import reportPdf from './posts/20260417100945-concealment-obfuscation-report.pdf';

export default function Concealment() {
  return (
    <main className="content" style={{ paddingTop: 16 }}>
      <iframe
        title="COMP 4900 Final Report"
        src={reportPdf}
        style={{
          width: '100%',
          height: 'calc(100vh - 140px)',
          border: 'none',
          borderRadius: 6,
          background: '#fff',
        }}
      />
    </main>
  );
}
